/**
 * Sends the active admin market (PT/BR) to the database on every data request.
 * The database only uses it to NARROW a global (superadmin) user's view;
 * scoped admins stay locked to their own market server-side.
 */
export const ADMIN_MARKET_HEADER = "x-hx-admin-market";

export function shouldTagRequest(url: string, supabaseUrl: string): boolean {
  return !!supabaseUrl && url.startsWith(`${supabaseUrl}/rest/v1/`);
}

export function installAdminMarketHeader(getMarket: () => string, supabaseUrl: string) {
  if (typeof window === "undefined" || (window as any).__hxMarketFetch) return;
  (window as any).__hxMarketFetch = true;
  const original = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
    if (!shouldTagRequest(url, supabaseUrl)) return original(input, init);
    const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
    headers.set(ADMIN_MARKET_HEADER, getMarket());
    return original(input, { ...init, headers });
  };
}
